export default "__VITE_ASSET__DHYwokQo__"